import React, { useState, useEffect } from 'react';

import clsx from 'clsx';


const Answer = ({answer, is_true, id, updateAnswers}) => {
  const [checked, setChecked] = useState(false);
  useEffect(() =>
    setChecked(false)
  , [id])
  const isAnswered = is_true || is_true === false;
  const onClick = () => {
    if(!isAnswered) {
      updateAnswers(id);
      setChecked(!checked);
    }
  };
  return (
    <p className={clsx(
      "is-size-4 is-vcentered p-3 m-0",
      {"has-background-success-light has-text-success": is_true},
      {"has-background-danger-light has-text-danger": checked && is_true === false},
      {"is-clickable": !isAnswered},
      {"has-background-primary-light": checked})}
        onClick={onClick}>
      {/*
      Change color if validated and right or false
      Click on answer, select checkbox, highlight selected line
      Border between answer
      */}
      <input type="checkbox" checked={checked} onClick={onClick} /> {answer}
    </p>
  )
}

const Answers = ({middleQuestion, answers, updateAnswers}) => {
  const answersComponents = answers.map((answer) => <Answer {...answer} updateAnswers={updateAnswers} />)
  if (!!middleQuestion)
    answersComponents.splice(2, 0, (<h4 className="title is-4">{middleQuestion}</h4>));
  return (
    <div>
      {answersComponents.map((cmp) =>
          cmp
      )}
    </div>
  )
}

export default Answers;